import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const BestallElavtal = lazy(() => import("@/pages/elavtal/BestallElavtal"));

export const Route = createFileRoute("/elavtal/bestall")({
  head: () => ({
    meta: [
      { title: "Beställ elavtal » Elmarknad.se" },

      {
        name: "description",
        content:
          "Slutför din beställning av elavtal direkt hos Elmarknad.se – fyll i dina uppgifter så tar elbolaget hand om bytet.",
      },
      { property: "og:title", content: "Beställ elavtal » Elmarknad.se" },
      {
        property: "og:description",
        content: "Slutför din beställning av elavtal direkt hos Elmarknad.se.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <BestallElavtal />,
});
